/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";

export function TrendingAMP({ color = "#c0c0c0" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.16 62.27">
      <defs />
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            className="cls-1"
            fill="none"
            stroke="#707070"
            strokeWidth={4}
            strokeMiterlimit={10}
            d="M7.63,20.64c-.07,5.21.7,10,4.9,13.78a3.8,3.8,0,0,0,.14-.91c0-.46-.16-.91-.24-1.37a38.05,38.05,0,0,1,.18-14.62,22.81,22.81,0,0,1,7.2-11.76c1.39-1.27,3-2.31,4.5-3.44a7.1,7.1,0,0,1,.77-.4c-.19.67-.33,1.14-.46,1.62-1.07,4,.06,7.42,2.65,10.48a36.25,36.25,0,0,0,6.16,5.38,29.4,29.4,0,0,1,7.07,7.05C46.57,35.49,45,49,36.56,56a23.11,23.11,0,0,1-4.07,2.72C18.55,66.14,3.14,56.3,1.32,42.55A26.86,26.86,0,0,1,3,27.84,23.89,23.89,0,0,1,7.63,20.64Z"
          />
          <path
            className="cls-2"
            fill="none"
            stroke="#e92227"
            strokeWidth={4}
            strokeMiterlimit={10}
            d="M11.5,49.37c4.32,4.55,10.83,6.83,17.83,3.9A15.76,15.76,0,0,0,38.54,36C37.17,29.62,32,24.82,27.86,24.14c.35.74.69,1.42,1,2.12a28.73,28.73,0,0,1,1.76,4c1.67,5.93-1.09,13.15-6.25,16.64a3.63,3.63,0,0,1-.56.22C24.78,44,25.7,41,25,37.73,22.79,44.24,18.3,48.08,11.5,49.37Z"
          />
        </g>
      </g>
    </svg>
  );
}
TrendingAMP.propTypes = {
  color: PropTypes.string
};
